// Клавиатура строки-ссылки (div role="link"/"button" tabIndex=0): Enter/Space открывают, как клик. Только если клавишу
// нажали на самой строке: со вложенной кнопки (звезда избранного) событие всплывает сюда — его не трогаем, иначе
// preventDefault гасит нажатие кнопки, а человека уводит на экран матча (HQ-1394).
import type { KeyboardEvent } from 'react';

export function rowKeyHandler(open: () => void) {
  return (e: Pick<KeyboardEvent, 'key' | 'target' | 'currentTarget' | 'preventDefault'>) => {
    if (e.target !== e.currentTarget || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault();
    open();
  };
}
